var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccomodation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 48,
    viewBox: "0 0 30 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#81ae4a;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "accommodation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map_pin_fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.33,4.91A14.6,14.6,0,0,0,4.67,25.56S15,35.68,15,47.37c0-11.68,10.33-21.8,10.33-21.8A14.6,14.6,0,0,0,25.33,4.91Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.54,18.11v3.25h1.63V16.49H6.46V9.84a.81.81,0,1,0-1.63,0V21.36H6.46V18.11ZM9,13.17a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,9,13.17Zm16.12,2.09v-2A1.22,1.22,0,0,0,24,12.15L12.19,11H12.1a.77.77,0,0,0-.76.75V14h-3c-.41,0-.74.2-.74.61s.33.61.74.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccomodation);
export default __webpack_public_path__ + "static/media/accomodation.3317a9cf199efb680921a5e3aad52aef.svg";
export { ForwardRef as ReactComponent };